import React, { useState, useEffect } from 'react';

import Sidenav from './Sidenav.js'
import Header from './Header.js'
import {Sketchbook, DynamicSketchbook} from './Sketchbook.js'
import SketchbookDetail from './SketchbookDetail.js'
import Footer from './Footer.js';

import './Grayson.css';

const Grayson = (props) => {

	function importAll(r) {
		return r.keys().map(r);
	}

	const photos = importAll(
		require.context(
			"../public/res/grayson-perry-as-claire-2025",
			false,
			/.*\.(png|jpe?g|svg)$/)
	);

	const [showScrollbar, setShowScrollbar] = useState(true);

	useEffect(() => {
		if (showScrollbar) {
			document.body.style.overflowY = 'auto';
		} else {
			document.body.style.overflowY = 'hidden';
		}
	}, [showScrollbar]);

	const [sidenavOpen, setSidenavOpen] = useState(false);
	const [sketchbookDetailOpen, setSketchbookDetailOpen] = useState(false);

	useEffect(() => {
		setShowScrollbar(!sketchbookDetailOpen);
	}, [sketchbookDetailOpen]);

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
	}, [])

	const [images, setImages] = useState([]);

	useEffect(() => {
		const gallery = photos.map(async (image, index) => {
			const url = image;
			let detail = null
			// if (!image.includes('PXL')) {
			// 	detail = 'Photo by <a href="https://www.mattwreford.net" target="_blank" rel="noopener noreferrer">Matt Wreford</a>'
			// }
			try {
				return ({
					url: url,
					detail: detail
				});
			} catch {
				return null;
			}
		})
		Promise.all(gallery).then(function (images) {
			setImages(images.filter(Boolean));
		});
	}, []);

	return (
		<div>
			<Sidenav
				setSidenavOpen={setSidenavOpen}
				isSidenavOpen={sidenavOpen && !sketchbookDetailOpen}
				setSketchbookDetailOpen={() => setSketchbookDetailOpen(true)}/>
			<SketchbookDetail
				setSketchbookDetailOpen={setSketchbookDetailOpen}
				isSketchbookDetailOpen={sketchbookDetailOpen}/>
			<Header
				hideHeader={sidenavOpen || sketchbookDetailOpen}
				setSidenavOpen={setSidenavOpen}/>
			<div className={`main-content`}>
				<DynamicSketchbook
					descTitle={`
Context and background for 'Grayson Perry as Claire'. © 2026 Jill Bryars. All Rights Reserved.`}
					descBody={[
						"Created over two years, and standing at 73cm H.",
						<br/>,
						<br/>,
						"In 2003 the UK artist Grayson Perry was awarded The Turner Prize aged 43. Appearing as his alter ego Claire. A man wearing a beautiful satin frock and red patent Mary-Jane shoes. A potter had never won The Turner Prize. Let alone in a dress. The word pottery, as loaded as the nomination. Perry's acceptance speech commented that the art world had 'More trouble coming to terms with me being a potter than my choice of frocks'",
						<br/>,
						<br/>,
						"This year Grayson Perry celebrated his 65th birthday and a new exhibition in London at The Wallace Collection, titled Delusions of Grandeur.",
						<br/>,
						<br/>,
						"It feels appropriate to present this major work. In which I interrogate persona. Rendered as figuration in ceramic. Representative of the highly charged debate; this figure inhabits a metaphoric space. A symbolic arena that contextualises the emergence of this British artist. Drama and theatre, again centre-stage; providing an illustration for new audiences. This is, after all, a man in a frock. Forward facing; a slight hip-swivel. Arms crooked and palms outward. Choice of scale necessitates practical solutions. In this case assembled sections, brass riveting and ceramic conservation technologies.",
						<br/>,
						<br/>,
						"A special thank you to ",
						<a href='https://www.mattwreford.net' target='_blank' rel='noopener noreferrer'>Matt Wreford</a>,
						" for the photos."
					]}
					imgInfos={images}/>
			</div>
			<div className='footer-content'>
				<Footer/>
			</div>
		</div>
	);

}

export default Grayson;